import React, { FC, ReactNode } from 'react'
import { Modal } from '../../../atoms'

interface Props {
  isOpen: boolean
  title: string
  onCancel: () => void
  onOk: () => void
  body: string | ReactNode
  okText?: string
}

const ConfirmationModal: FC<Props> = ({
  isOpen,
  onCancel,
  onOk,
  body,
  title,
  okText = 'Confirm'
}) => {
  return (
    <div>
      <Modal
        title={title}
        visible={isOpen}
        centered={true}
        onOk={onOk}
        okText={okText}
        onCancel={onCancel}
        okButtonProps={{
          className: 'button-md'
        }}
        cancelButtonProps={{
          className: 'button-md'
        }}
      >
        {body}
      </Modal>
    </div>
  )
}

export default ConfirmationModal
